/* Signora: keep the Shopify Inbox chat button out of the way while people scroll on phones
   (20 Oct 2026). The button fades out during a scroll and comes back ~0.9 s after scrolling stops.
   Never hides it while the chat panel is open. The PDP sticky-bar lift stays in sjw-pdp-mobile-chat-lift.js. */
(function () {
  if (window.__sjwChatFab) return; window.__sjwChatFab = 1;
  var mq = window.matchMedia('(max-width: 749px)');
  var timer = null;
  function host() { return document.querySelector('shopify-chat'); }
  function panelOpen(h) {
    try {
      var rt = h.shadowRoot && h.shadowRoot.querySelector('shopify-agent-runtime');
      var panel = rt && rt.shadowRoot && rt.shadowRoot.querySelector('.panel');
      return !!(panel && panel.getBoundingClientRect().height > 0);
    } catch (e) { return false; }
  }
  function onScroll() {
    if (!mq.matches) return;
    var h = host(); if (!h || panelOpen(h)) return;
    h.classList.add('sjw-chat-away');
    clearTimeout(timer);
    timer = setTimeout(function () { h.classList.remove('sjw-chat-away'); }, 900);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
